export default function (state, getters, rootState, rootGetters) {
    return rootState.settings.invoices.load || state.list.loading || rootState.dictionary.invoiceStatus.load;
}